module.exports = __webpack_public_path__ + "img/Groupe 72.dc300b6a.svg";